import { Icon, IconButton, Typography } from "@/components/atoms";
import { BookingDetails } from "@/redux/slices/booking/types";
import { BookingStatusIcon } from "../../../common/BookingStatusIcon/BookingStatusIcon";
import { statusMapping } from "../../../fixtures";

interface BookingHeaderProps {
  booking: BookingDetails;
  onClose: () => void;
}

export const BookingHeader = ({ booking, onClose }: BookingHeaderProps) => {
  const statusObj = statusMapping[booking.status];
  return (
    <header className="flex items-center justify-between p-5">
      <div className="flex items-center gap-2">
        <Icon name="ArchiveBook" className="text-neutral-dark-gray" />
        <Typography variant="title">Booking {booking && `${booking.jobNumber}`}</Typography>
        <BookingStatusIcon
          status={{
            color: statusObj.color,
            icon: statusObj.icon,
          }}
        />
        <Typography variant="paragraph">{statusObj.legend}</Typography>
      </div>
      <div className="ml-3 flex h-7 items-center">
        <IconButton iconName="ArrowRight" onClick={onClose} className="-mr-2" variant="custom" />
      </div>
    </header>
  );
};
